// sorting.service.ts
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

type SortDirection = "desc" | "asc";

@Injectable({
    providedIn: "root",
})
export class SortingHomeService {
    private sortingSubject = new BehaviorSubject<{
        key: string;
        value: SortDirection;
    }>({ key: "flightDate", value: "desc" });
    currentSorting$ = this.sortingSubject.asObservable();

    updateSorting(sorting: { key: string; value: SortDirection }) {
        this.sortingSubject.next(sorting);
    }
}
